import React from 'react';
import { Checkbox } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
const FieldCheckbox = (props) => {
  const { disabled, title, label, name } = props;

  return (
    <Section
      {...{
        size: 'small',
        bottomBorder: false,
        style: { paddingTop: 0, marginBottom: 1, backgroundColor: '#fff' },
      }}>
      <ItemWrapper title={title}>
        <Field name={name} valuePropName={'checked'}>
          {(props, meta) => {
            return (
              <Checkbox disabled={disabled} {...props} {...meta}>
                <span>{label}</span>
              </Checkbox>
            );
          }}
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default FieldCheckbox;
